import { useNavigate, useParams } from "react-router-dom";
import { NavBar, NavLink } from "./NavBar";
import { useAuth } from "../auth/AuthProvider";
import { useState } from "react";
import { useLayer, Arrow } from "react-laag";
import { portalRoutes } from "../routes/portalRoutes";
import { Mail, User } from "lucide-react";

const logo = "/images/logo-small-zickko.svg";

interface AuthNavbarProps {
  showUserIcon: boolean;
  showNavLinks?: boolean;
}

export const AuthNavbar = (props: AuthNavbarProps) => {
  const navigateTo = useNavigate();
  const auth = useAuth();
  const { orgId } = useParams<{ orgId: string }>();
  const [isOpen, setIsOpen] = useState(false);

  const navLinks: NavLink[] = orgId
    ? [
        { label: "Dashboard", onClick: () => navigateTo(portalRoutes.orgs.org.dashboard.link({ orgId }, {})) },
        { label: "Users", onClick: () => navigateTo(portalRoutes.orgs.org.members.list.link({ orgId }, {})) },
        { label: "Groups", onClick: () => navigateTo(portalRoutes.orgs.org.groups.list.link({ orgId }, {})) },
        { label: "Billing", onClick: () => {} },
        { label: "Settings", onClick: () => navigateTo(portalRoutes.orgs.org.edit.link({ orgId }, {})) },
      ]
    : [];

  const { renderLayer, triggerProps, layerProps, arrowProps } = useLayer({
    isOpen,
    onOutsideClick: () => setIsOpen(false),
    onDisappear: () => setIsOpen(false),
    placement: "bottom-end",
    triggerOffset: 22,
  });

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const logout = () => {
    auth.logout();
    setIsOpen(false);
  };

  return (
    <NavBar
      logo={{ src: logo, alt: "Zickko Logo" }}
      links={props.showNavLinks ? navLinks : []}
      actions={[
        {
          icon: (
            <button className="zickko-button">
              <Mail className="icon" strokeWidth={1.75} />
              Access zickko
            </button>
          ),
          action: () => {},
        },
        ...(props.showUserIcon
          ? [
              {
                icon: (
                  <div className="user-icon-container">
                    <button className="icon-button" {...triggerProps} onClick={toggleDropdown}>
                      <User className="icon" strokeWidth={3} />
                    </button>
                    {isOpen &&
                      renderLayer(
                        <div className="dropdown-menu" {...layerProps}>
                          <Arrow
                            {...arrowProps}
                            layerSide="bottom"
                            onPointerEnterCapture={() => {}}
                            onPointerLeaveCapture={() => {}}
                          />
                          <button
                            className="dropdown-buttons switch-button"
                            onClick={() => navigateTo(portalRoutes.orgs.select.link({}, {}))}
                          >
                            Example Studios <br />
                            <span>Switch Organization</span>
                          </button>

                          <button className="dropdown-buttons logged-in-button">
                            Logged in as <br />
                            <span>{auth.user?.email}</span>
                          </button>
                          <button
                            className="dropdown-buttons"
                            onClick={() =>
                              orgId
                                ? navigateTo(portalRoutes.orgs.org.edit.link({ orgId: orgId }, {}))
                                : navigateTo(portalRoutes.orgs.create.link({}, {}))
                            }
                          >
                            Settings
                          </button>
                          <button className="dropdown-buttons" onClick={logout}>
                            Logout
                          </button>
                        </div>
                      )}
                  </div>
                ),
                action: () => {},
              },
            ]
          : []),
      ]}
    />
  );
};
